import {
  firestore,
  timeStampFromDate,
} from '../../../../functions/firebase/firebaseAccess';

export const FIVE_MINUTES = 5 * 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const UPCOMING_SHOW_OVER_TIME_LIMIT = FIFTEEN_MINUTES;

const profilesCollection = () => firestore().collection('profiles');

export const profileCodeQuery = (code: string) =>
  profilesCollection().where('urlCode', '==', code.toLowerCase()).limit(1);

export const profileUsernameQuery = (userName: string) =>
  profilesCollection().where('username', '==', userName).limit(1);

export const profileQuery = (uid: string) => profilesCollection().doc(uid);

export const eventShowCodeQuery = (code: string) =>
  firestore().collection('showEvents').where('urlCode', '==', code).limit(1);

export const eventShowQuery = (eventId: string) =>
  firestore().collection('showEvents').doc(eventId);

export const sellerLatestLiveStreamQuery = (seller: string) =>
  firestore()
    .collection('liveStreams')
    .where('primary.userId', '==', seller)
    .where('primary.status.finished', '==', false)
    .where('primary.status.aborted', '==', false)
    .limit(1);

export const sellerNextUpcomingShow = (sellerId: string) =>
  firestore()
    .collection('upcomingShows')
    .where('userId', '==', sellerId)
    .where('available', '==', true)
    .where(
      'startsAt',
      '>=',
      timeStampFromDate(new Date(Date.now() - UPCOMING_SHOW_OVER_TIME_LIMIT)),
    )
    .orderBy('startsAt')
    .limit(1);

export const liveStreamDoc = (id: string) =>
  firestore().collection('liveStreams').doc(id);

export const upcomingShowDoc = (id: string) =>
  firestore().collection('upcomingShows').doc(id);

export const promotionDoc = (id: string) =>
  firestore().collection('appGlobal').doc(id);

export const storeDoc = (id: string) =>
  firestore().collection('stores').doc(id);
